export { groupPatchedDependencies } from './groupPatchedDependencies.ts';
export { getPatchInfo } from './getPatchInfo.ts';
export { type VerifyPatchesOptions, verifyPatches } from './verifyPatches.ts';
